import { WORDS } from '../constants/wordlist'
import { VALID_GUESSES } from '../constants/validGuesses'
import { WRONG_SPOT_MESSAGE, NOT_CONTAINED_MESSAGE } from '../constants/strings'
import { getGuessStatuses } from './statuses'

export const isWordInWordList = (word: string) => {
  return (
    WORDS.includes(word.toUpperCase()) ||
    VALID_GUESSES.includes(word.toUpperCase())
  )
}

export const isWinningWord = (word: string) => {
  return solution === word
}

// build a set of previously revealed letters - present and correct
// guess must use correct letters in that space and any other revealed letters
// also check if all revealed instances of a letter are used (i.e. two C's)
export const findFirstUnusedReveal = (word: string, guesses: string[]) => {
  if (guesses.length === 0) {
    return false
  }

  const lettersLeftArray = new Array<string>()
  const guess = guesses[guesses.length - 1]
  const statuses = getGuessStatuses(guess)

  for (let i = 0; i < guess.length; i++) {
    if (statuses[i] === 'correct' || statuses[i] === 'present') {
      lettersLeftArray.push(guess[i])
    }
    if (statuses[i] === 'correct' && word[i] !== guess[i]) {
      return WRONG_SPOT_MESSAGE(guess[i], i + 1)
    }
  }

  // check for the first unused letter, taking duplicate letters
  // into account - see issue #198
  let n
  for (const letter of word) {
    n = lettersLeftArray.indexOf(letter)
    if (n !== -1) {
      lettersLeftArray.splice(n, 1)
    }
  }

  if (lettersLeftArray.length > 0) {
    return NOT_CONTAINED_MESSAGE(lettersLeftArray[0])
  }
  return false
}

// compare current max offset against standard time offset
export const hasTimeOffset = function () {
  const myDate = new Date()
  const jan = new Date(myDate.getFullYear(), 0, 1) // standard time
  const jul = new Date(myDate.getFullYear(), 6, 1) // summer time

  const maxOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) 
  // compare standard time offset with what the current max offset
  return myDate.getTimezoneOffset() < maxOffset
}

export const getWordOfDay = () => {
  var epochMs = new Date('February 14, 2022 00:00:00').valueOf()

  // if stard time offset is less than the current offset, subtract an hour
  // this usually happens on daylight affected time zones (in summer)
  if (hasTimeOffset()) {
    epochMs = epochMs - 3600000 // adjust for DST and remove an hour (3600000 ms)
  }

  const now = Date.now()
  const msInDay = 86400000
  const index = Math.floor((now - epochMs) / msInDay)
  const nextday = (index + 1) * msInDay + epochMs

  return {
    solution: WORDS[index % WORDS.length].toUpperCase(),
    solutionIndex: index,
    tomorrow: nextday,
  }
}

export const { solution, solutionIndex, tomorrow } = getWordOfDay()
